<ng-container rtBlock="feedback-form">
    @if (status() === SubmissionStatus.Success) {
        <div rtElem="success" role="status">
            <p i18n="@@feedbackSuccess">Спасибо! Мы свяжемся с вами.</p>
            <button rtElem="link" rtButton appearance="text" type="button" i18n="@@feedbackSendAnother" (click)="sendAnother()">
                Отправить ещё одно сообщение
            </button>
        </div>
    } @else {
        <form novalidate [class]="['feedback-form'] | concatClasses" (submit)="onSubmit($event)">
            <rt-field rtElem="field" i18n-label="@@feedbackEmailLabel" label="Email*" [hideRequiredMark]="true">
                <rt-input
                    type="email"
                    autocomplete="email"
                    i18n-placeholder="@@feedbackEmailPlaceholder"
                    placeholder="your@email.com"
                    [clearable]="false"
                    [formField]="form.email" />
            </rt-field>

            <rt-field rtElem="field" i18n-label="@@feedbackMessageLabel" label="Сообщение*" [hideRequiredMark]="true">
                <rt-textarea
                    resize="vertical"
                    i18n-placeholder="@@feedbackMessagePlaceholder"
                    placeholder="Опишите пожелание или проблему"
                    [rows]="4"
                    [formField]="form.message" />
            </rt-field>

            <div #captchaContainer rtElem="captcha"></div>

            <button rtElem="submit" rtButton type="submit" [disabled]="form().invalid() || status() === SubmissionStatus.Submitting">
                @if (status() === SubmissionStatus.Submitting) {
                    <span i18n="@@feedbackSubmitting">Отправка...</span>
                } @else {
                    <span i18n="@@feedbackSubmit">Отправить</span>
                }
            </button>
        </form>
    }
</ng-container>
